<template>
  <v-container>
    <template v-if="_aplicacao != 'NAO_APLICAR'">
      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox v-model="_janelaDataImob" label="Incluir janela na data de imobilização?" hide-details class="my-0 py-0" />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox
            v-model="_desconsiderarItensZeradosOuNegativos"
            label="Desconsiderar itens zerados ou negativos"
            hide-details
            class="my-0 py-0"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox
            v-model="_expurgarItensRacionalizacaoCOM"
            label="Expurgar itens de Racionalização do COM"
            hide-details
            class="my-0 py-0"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox v-model="_expurgarItensMop" label="Expurgar itens MOP" hide-details class="my-0 py-0" />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox v-model="_expurgarItensJoa" label="Expurgar itens JOA" hide-details class="my-0 py-0" />
        </v-col>
      </v-row>

      <v-row class="mt-2 mx-auto">
        <v-col cols="12" class="pb-0">
          <span style="color: #757575; font-size: 15px">Períodos para janelas de Data de Lançamento</span>
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col sm="4" cols="6">
          <v-text-field
            v-model="_periodosDataLancamento.diasAntes"
            label="Nº de dias antes"
            min="0"
            type="number"
            @blur="_periodosDataLancamento.diasAntes < 0 ? (_periodosDataLancamento.diasAntes = 0) : 1"
          />
        </v-col>
        <v-col sm="4" cols="6">
          <v-text-field
            v-model="_periodosDataLancamento.diasDepois"
            label="Nº de dias depois"
            min="0"
            type="number"
            @blur="_periodosDataLancamento.diasDepois < 0 ? (_periodosDataLancamento.diasDepois = 0) : 1"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pt-0">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header style="font-weight: 300; font-size: 15px">
                Períodos por Tipologia Aneel
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size: 13px">Redes Aéreas</span>
                  </v-col>

                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasAntesRedesAereas"
                      label="Nº de dias antes"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasAntesRedesAereas < 0 ? (_periodosDataLancamento.diasAntesRedesAereas = 0) : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasDepoisRedesAereas"
                      label="Nº de dias depois"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasDepoisRedesAereas < 0
                          ? (_periodosDataLancamento.diasDepoisRedesAereas = 0)
                          : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox
                      v-model="_periodosDataLancamento.aplicarPeriodoRedesAereas"
                      label="Aplicar período"
                      hide-details
                      class="my-0 py-0"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size: 13px">Redes Subterrâneas</span>
                  </v-col>

                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasAntesRedesSubterraneas"
                      label="Nº de dias antes"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasAntesRedesSubterraneas < 0
                          ? (_periodosDataLancamento.diasAntesRedesSubterraneas = 0)
                          : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasDepoisRedesSubterraneas"
                      label="Nº de dias depois"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasDepoisRedesSubterraneas < 0
                          ? (_periodosDataLancamento.diasDepoisRedesSubterraneas = 0)
                          : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox
                      v-model="_periodosDataLancamento.aplicarPeriodoRedesSubterraneas"
                      label="Aplicar período"
                      hide-details
                      class="my-0 py-0"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size: 13px">Medidores</span>
                  </v-col>

                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasAntesMedidores"
                      label="Nº de dias antes"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasAntesMedidores < 0 ? (_periodosDataLancamento.diasAntesMedidores = 0) : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasDepoisMedidores"
                      label="Nº de dias depois"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasDepoisMedidores < 0 ? (_periodosDataLancamento.diasDepoisMedidores = 0) : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox
                      v-model="_periodosDataLancamento.aplicarPeriodoMedidores"
                      label="Aplicar período"
                      hide-details
                      class="my-0 py-0"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size: 13px">Subestações</span>
                  </v-col>

                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasAntesSubestacoes"
                      label="Nº de dias antes"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasAntesSubestacoes < 0 ? (_periodosDataLancamento.diasAntesSubestacoes = 0) : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasDepoisSubestacoes"
                      label="Nº de dias depois"
                      min="0"
                      type="number"
                      @blur="
                        _periodosDataLancamento.diasDepoisSubestacoes < 0
                          ? (_periodosDataLancamento.diasDepoisSubestacoes = 0)
                          : 1
                      "
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox
                      v-model="_periodosDataLancamento.aplicarPeriodoSubestacoes"
                      label="Aplicar período"
                      hide-details
                      class="my-0 py-0"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size: 13px">Linhas</span>
                  </v-col>

                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasAntesLinhas"
                      label="Nº de dias antes"
                      min="0"
                      type="number"
                      @blur="_periodosDataLancamento.diasAntesLinhas < 0 ? (_periodosDataLancamento.diasAntesLinhas = 0) : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      v-model="_periodosDataLancamento.diasDepoisLinhas"
                      label="Nº de dias depois"
                      min="0"
                      type="number"
                      @blur="_periodosDataLancamento.diasDepoisLinhas < 0 ? (_periodosDataLancamento.diasDepoisLinhas = 0) : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox
                      v-model="_periodosDataLancamento.aplicarPeriodoLinhas"
                      label="Aplicar período"
                      hide-details
                      class="my-0 py-0"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
  export default {
    name: 'SaneamentoVocFlagData',

    props: {
      aplicacao: {
        type: String,
        required: true
      },
      janelaDataImob: {
        type: Boolean,
        default: undefined
      },
      periodosDataLancamento: {
        type: Object,
        default: () => {}
      },
      desconsiderarItensZeradosOuNegativos: {
        type: Boolean,
        default: undefined
      },
      expurgarItensRacionalizacaoCOM: {
        type: Boolean,
        default: undefined
      },
      expurgarItensMop: {
        type: Boolean,
        default: undefined
      },
      expurgarItensJoa: {
        type: Boolean,
        default: undefined
      }
    },

    emits: [
      'update:aplicacao',
      'update:janelaDataImob',
      'update:periodosDataLancamento',
      'update:desconsiderarItensZeradosOuNegativos',
      'update:expurgarItensRacionalizacaoCOM',
      'update:expurgarItensMop',
      'update:expurgarItensJoa'
    ],

    computed: {
      _aplicacao: {
        get() {
          return this.aplicacao;
        },
        set(newValue) {
          this.$emit('update:aplicacao', newValue);
        }
      },
      _janelaDataImob: {
        get() {
          return this.janelaDataImob;
        },
        set(newValue) {
          this.$emit('update:janelaDataImob', newValue);
        }
      },
      _periodosDataLancamento: {
        get() {
          return this.periodosDataLancamento;
        },
        set(newValue) {
          this.$emit('update:periodosDataLancamento', newValue);
        }
      },
      _desconsiderarItensZeradosOuNegativos: {
        get() {
          return this.desconsiderarItensZeradosOuNegativos;
        },
        set(newValue) {
          this.$emit('update:desconsiderarItensZeradosOuNegativos', newValue);
        }
      },
      _expurgarItensRacionalizacaoCOM: {
        get() {
          return this.expurgarItensRacionalizacaoCOM;
        },
        set(newValue) {
          this.$emit('update:expurgarItensRacionalizacaoCOM', newValue);
        }
      },
      _expurgarItensMop: {
        get() {
          return this.expurgarItensMop;
        },
        set(newValue) {
          this.$emit('update:expurgarItensMop', newValue);
        }
      },
      _expurgarItensJoa: {
        get() {
          return this.expurgarItensJoa;
        },
        set(newValue) {
          this.$emit('update:expurgarItensJoa', newValue);
        }
      }
    }
  };
</script>

<style></style>
